module.exports = __webpack_public_path__ + "static/img/mxpz.2697867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mxpz.png
// module id = 0Uyq
// module chunks = 3